import React, {
  createContext,
  useContext,
  ReactNode,
  useEffect,
  useState,
} from 'react';
import useTomoUserInfo from './hooks/useTomoUserInfo';
import { UserType } from './types/types';
import { useInitData, useWebApp } from '@vkruglikov/react-telegram-web-app';
import { InitDataUnsafe } from '@vkruglikov/react-telegram-web-app/lib/useInitData';
import { api, loginApi } from './api';
import { userKey } from './state/storageKey';
import usePaymentPasswd from './hooks/usePaymentPasswd';
import useStore from './state/useStore';
import useBiometricManager from './hooks/useBiometricManager';
import Proviers from './providers';
import useCheckLoginByCode from './hooks/api/useCheckLoginByCode';
import { generateRandomString } from './util';

type EnvType = 'dev' | 'test' | 'main';
type TomoContextType = {
  env: EnvType;
  tmaid: string;
  tmakey: string;
  endpoints: [string];
  onLogin: () => Promise<any>;
  userInfo: UserType | null;
  onLogout: () => void;
  telegramData: InitDataUnsafe;
  tMAuthLink: string;
};
export const defaultEndpoints: {
  [key in EnvType]: [string];
} = {
  dev: ['https://apis.tomo.inc/'],
  test: ['https://apis.tomo.inc/'],
  main: ['https://apis.tomo.inc/'],
};
export const defaultTMAuthLink = 'https://t.me/tomowalletbot/tomoauthapp';

const TomoContext = createContext<TomoContextType | undefined>(undefined);

export const TomoProvider: React.FC<{
  children: ReactNode;
  tmaid: string;
  tmakey: string;
  env?: EnvType;
  customEndpoints?: [string];
  customTMAuthLink?: string;
}> = ({
  children,
  tmaid,
  tmakey,
  env = 'dev',
  customEndpoints,
  customTMAuthLink,
}) => {
  const [code, setCode] = useState('');
  const { data, isLoading } = useCheckLoginByCode(code);
  const webApp = useWebApp();
  const { checkPasswd } = usePaymentPasswd();
  const { setPaymentPwdExists, paymentPwdExists } = useStore();

  const [initDataUnsafe, initData] = useInitData();
  const {
    setUserInfo,
    userInfo,
    deviceId,
    generateDeviceId,
  } = useTomoUserInfo();

  const endpoints = customEndpoints || defaultEndpoints[env];
  const tMAuthLink = customTMAuthLink || defaultTMAuthLink;
  useEffect(() => {
    api.init(endpoints, tmaid, tmakey);
    if (userInfo?.id) {
      checkPasswd();
    }
  }, [endpoints, tmaid, tmakey]);

  const onLogin = async () => {
    const c = generateRandomString(16);
    console.log('code', c);
    setCode(c);
    webApp?.openTelegramLink(tMAuthLink + '?startapp=' + c);
    return tMAuthLink + '?startapp=' + c;
    // if (!initData) {
    //   throw new Error('Please open the telegram and try again');
    // }
    // const res = await loginApi(`${initData}`);
    // setUserInfo(res);
    // if (!deviceId) {
    //   await generateDeviceId();
    // }
    // await checkPasswd();
    //
    // return res;
  };
  useEffect(() => {
    (async () => {
      if (code) {
        setUserInfo(data);
        if (data) {
          if (!deviceId) {
            await generateDeviceId();
          }
          await checkPasswd();
        }
      }
    })();
  }, [data, code]);

  const onLogout = () => {
    setUserInfo(null);
    setPaymentPwdExists(-1);
  };

  return (
    <Proviers>
      <TomoContext.Provider
        value={{
          tmaid,
          tmakey,
          env,
          endpoints,
          userInfo,
          onLogin,
          onLogout,
          telegramData: initDataUnsafe,
          tMAuthLink,
        }}
      >
        {children}
      </TomoContext.Provider>
    </Proviers>
  );
};

export const useTomo = () => {
  const context = useContext(TomoContext);

  if (context === undefined) {
    throw new Error('useTomo must be used within a TomoProvider');
  }
  return context;
};
